import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import BackToHome from "@/components/portal/BackToHome";

export default function PortalShell({ ribbon, title, sub, user, onSignOut, bell, children }) {
  const nav = useNavigate();
  return (
    <div className="portal">
      <div className="ribbon">{ribbon}</div>
      <div className="top">
        <div className="brand" onClick={() => nav("/")} data-testid="portal-brand">
          <div className="logo">2</div>
          <div><h1>{title}</h1><p>{sub}</p></div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          {bell}
          {user && (
            <button className="signout" onClick={onSignOut} data-testid="portal-signout">
              <LogOut size={15} /> Sign out
            </button>
          )}
        </div>
      </div>
      <div className="wrap">
        <div className="portal-backnav"><BackToHome /></div>
        {children}
      </div>
    </div>
  );
}
